import { createPlugin, createApiFactory, createRoutableExtension } from '@backstage/core-plugin-api';
import { GraphQLEndpoints } from './lib/api/GraphQLEndpoints.esm.js';
import { graphQlBrowseApiRef } from './lib/api/types.esm.js';
import { graphiQLRouteRef } from './route-refs.esm.js';

const graphiqlPlugin = createPlugin({
  id: "graphiql",
  apis: [
    // GitLab is used as an example endpoint, but most will want to plug in
    // their own instead.
    createApiFactory(
      graphQlBrowseApiRef,
      GraphQLEndpoints.from([
        GraphQLEndpoints.create({
          id: "gitlab",
          title: "GitLab",
          url: "https://gitlab.com/api/graphql"
        })
      ])
    )
  ]
});
const GraphiQLPage = graphiqlPlugin.provide(
  createRoutableExtension({
    name: "GraphiQLPage",
    component: () => import('./components/index.esm.js').then((m) => m.GraphiQLPage),
    mountPoint: graphiQLRouteRef
  })
);

export { GraphiQLPage, graphiqlPlugin };
//# sourceMappingURL=plugin.esm.js.map
